<template>
  <v-app>
    <rg-header @signout="askSignOut()" @toggle="collapsed = !collapsed"></rg-header>
    <rg-navigation :collapsed="collapsed"></rg-navigation>
    
    <v-overlay :value="overlay" color="white" :opacity="opacity" :z-index="zIndex">
      <v-card flat tile elevation="0" color="transparent">
        <v-card-title class="headline grey--text">{{ title }}</v-card-title>
        <v-card-subtitle class="grey--text">{{ message }}</v-card-subtitle>
        <v-card-text>
          <v-progress-linear color="red" indeterminate rounded height="6"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-overlay :value="locked" color="white" :opacity="opacity" :z-index="zIndex">
      <v-card flat tile elevation="0" color="transparent">
        <v-card-title class="headline grey--text">Accesso non eseguito</v-card-title>
        <v-card-subtitle class="grey--text">Sei stato disconnesso dalla sessione. Effettua di nuovo l'accesso</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="$router.push('/')">Accedi</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>

    <v-content>
      <router-view transition="slide-x-transition"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import RgHeaderVue from './components/skeleton/RgHeader.vue';
import RgNavigationVue from './components/skeleton/RgNavigation.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TimeReportClient',

  components: {
    'rg-header': RgHeaderVue,
    'rg-navigation': RgNavigationVue
  },

  data: ()=>({
    collapsed: true,
    overlay: false,
    locked: false,
    opacity: 0.95,
    zIndex: 300,
    title: '',
    message: ''
  }),

  getters: {
    ...mapGetters('oidcStore', [ 'oidcIsAuthenticated', 'oidcUser' ]),
    
    hasLicense(){
      return this.oidcUser.licenses.some((l)=> l === 'WTR');
    },

    isWtr(){ 
      return this.oidcUser.roles.some((l)=> l === 'wtr.reg' || l === 'wtr.admin');
    }
  },

  methods: {
    ...mapActions('argoStore', [ 'initSession', 'invalidateSession', 'removeSession', 'requestLogout' ]),
    ...mapActions('oidcStore', [ 'signOutOidc', 'removeOidcUser' ]),

    initializeArgoContext(event){
      this.title = 'Attendere prego...';
      this.message = 'Creazione dello spazio di lavoro in corso...';
      this.overlay = true;

      const user = event.detail.profile;
      const userHasLicense = (user.licenses.some((l)=> l === 'WTR'));
      const isWtrUser = (user.roles.some((r)=> r === 'wtr.reg' || r === 'wtr.admin'));

      if(userHasLicense && isWtrUser){
        this.initSession().then((session)=> {
          const route = (session.roles.some((r)=> r === 'wtr.admin')) ? '/search' : '/calendar';
          this.overlay = false;
          if(this.$route.path !== route) this.$router.push(route);
          
        })
        .catch((e)=> console.error('exception:', e));
      }
      else this.$router.push('/error/unauthorized');
    },

    askSignOut(){      
      this.title = 'Attendere prego...';
      this.message = 'Disconnessione dai servizi in corso...';
      this.overlay = true;

      this.removeSession().then((successfullySignedOff)=> {
        if(successfullySignedOff){
          window.removeEventListener('argo:logout', this.signOut);
          this.signOutOidc();
          this.requestLogout();
        }
      });      
    },

    signOut(){
      this.locked = true;
      this.removeSession().then((successfullySignedOff)=> {
        if(successfullySignedOff) this.removeOidcUser();
      });
    },

    accessTokenExpired(){
      console.debug('accessTokenExpired: remove user session from WebStorage');
      this.removeSession().then((successfullyRemoved)=> {
        if(successfullyRemoved){
          console.log('user successfully removed');
          this.locked = true;
        }
      });
    },

    accessTokenExpiring(){
      console.log('accessTokenExpiring, try the silent renew');
    },

    silentRenewError(){
      console.log('silent renew error');
    }
  },

  created(){
    if(!process.env.NODE_ENV === 'development')
      this.$router.replace(this.$route.query.redirect || '/')
  },

  mounted(){
    window.addEventListener('argo:logout', this.signOut);
    window.addEventListener('vuexoidc:userLoaded', this.initializeArgoContext);
    window.addEventListener('vuexoidc:accettTokenExpiring', this.accessTokenExpiring);
    window.addEventListener('vuexoidc:accessTokenExpired', this.accessTokenExpired);
  },

  destroyed(){
    window.removeEventListener('argo:logout', this.signOut);
    window.removeEventListener('vuexoidc:userLoaded', this.initializeArgoContext);
    window.removeEventListener('vuexoidc:accettTokenExpiring', this.accessTokenExpiring);
    window.removeEventListener('vuexoidc:accessTokenExpired', this.accessTokenExpired);
  }
}
</script>